import React, { useEffect, useState } from 'react';
import { CallAPIGetPromise } from 'Common/commaon';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

type LoginActivity = {
  logged_in_at: string; login_source: string; login_method: string;
  ip_address: string | null; city: string | null; state: string | null;
  country: string | null; user_agent: string | null;
};
export function ContractorLatestLogin({ contractorId }: { contractorId: string | number }) {
  const [activity, setActivity] = useState<LoginActivity | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    setActivity(null);
    CallAPIGetPromise(`/admin/contractors/${encodeURIComponent(contractorId)}/latest-login`)
      .then((response) => { if (active) setActivity((response as { data: LoginActivity | null }).data); })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [contractorId, refresh]);
  const fields = activity ? [
    ['Time', new Date(activity.logged_in_at).toLocaleString()],
    ['Source', activity.login_source], ['Method', activity.login_method],
    ['IP address', activity.ip_address || 'Unavailable'],
    ['Approximate location', [activity.city, activity.state, activity.country].filter(Boolean).join(', ') || 'Unavailable'],
    ['Browser / device', activity.user_agent || 'Unavailable'],
  ] : [];
  return <Card>
    <CardHeader><CardTitle>Latest login activity</CardTitle></CardHeader>
    <CardContent>
      {loading ? <p role="status">Loading login activity…</p> : error ? <div role="alert">
        <p>Unable to load login activity.</p>
        <Button variant="outline" onClick={() => setRefresh(value => value + 1)}>Retry</Button>
      </div> : !activity ? <p>No login recorded yet. Activity will appear after the next successful login.</p> : <>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {fields.map(([label, value]) => <div key={label} className="min-w-0">
            <dt className="text-sm text-muted-foreground">{label}</dt>
            <dd className="break-words">{value}</dd>
          </div>)}
        </dl>
        <p className="text-sm text-muted-foreground mt-4">Location is estimated from the IP address and may differ when using a VPN or mobile network.</p>
        <Button variant="outline" onClick={() => setRefresh(value => value + 1)}>Refresh</Button>
      </>}
    </CardContent>
  </Card>;
}
